import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import CreateOffer from './components/CreateOffer';
import CreateRestaurant from './components/CreateRestaurant';
import OffersList from './components/OffersList';
import RestaurantsList from './components/RestaurantsList';
import ImportMenu from './components/ImportMenu';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/create-offer" element={
            <ProtectedRoute>
              <CreateOffer />
            </ProtectedRoute>
          } />
          <Route path="/create-restaurant" element={
            <ProtectedRoute>
              <CreateRestaurant />
            </ProtectedRoute>
          } />
          <Route path="/offers-list" element={
            <ProtectedRoute>
              <OffersList />
            </ProtectedRoute>
          } />
          <Route path="/restaurants-list" element={
            <ProtectedRoute>
              <RestaurantsList />
            </ProtectedRoute>
          } />
          <Route path="/import-menu" element={
            <ProtectedRoute>
              <ImportMenu />
            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
